// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidMetaQueryVariables = Types.Exact<{
  itemFilter?: Types.InputMaybe<Types.ItemFilter>;
}>;


export type BidMetaQuery = { __typename?: 'Query', costTypes: Array<{ __typename?: 'CostTypeDetail', name: string, code: Types.CostType }>, items: Array<{ __typename?: 'Item', id: string, name: string }>, materialVariantTags: Array<{ __typename?: 'MaterialVariantTag', id: string, name: string }> };

export type EditBidMetaQueryVariables = Types.Exact<{
  itemFilter?: Types.InputMaybe<Types.ItemFilter>;
  bidPackageVersionId: Types.Scalars['ID']['input'];
}>;


export type EditBidMetaQuery = { __typename?: 'Query', costTypes: Array<{ __typename?: 'CostTypeDetail', name: string, code: Types.CostType }>, items: Array<{ __typename?: 'Item', id: string, name: string }>, materialVariantTags: Array<{ __typename?: 'MaterialVariantTag', id: string, name: string }>, bidPackageVersion: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string } }>, previous?: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string } }> } | null | undefined } };

export type EditBidPackageLineItemModal_LineItemFragment = { __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string } };

export type BidPackageLineItemModalQueryVariables = Types.Exact<{
  filter: Types.PotentialBidItemsPageFilter;
  order?: Types.InputMaybe<Types.BidItemOrder>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type BidPackageLineItemModalQuery = { __typename?: 'Query', potentialBidItemsPage: { __typename?: 'BidItemsPage', bidItems: Array<{ __typename?: 'BidItem', name: string, id: string, displayName: string, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type BidPackageLineItemModal_BidItemFragment = { __typename?: 'BidItem', name: string, id: string, displayName: string, parentTask?: { __typename?: 'GlobalPlanTask', id: string, name: string } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, abbreviation: string }, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string, displayName: string } | null | undefined, items: Array<{ __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType } };

export type BidPackageLineItemModal_BidPackageFragment = { __typename?: 'BidPackage', id: string, name: string, isUnitBased: boolean, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string, displayName: string, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> } }>, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }> };

export type BidPackageLineItemModal_BidPackageLineItemFragment = { __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string, displayName: string, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> } };

export const EditBidPackageLineItemModal_LineItemFragmentDoc = gql`
    fragment EditBidPackageLineItemModal_LineItem on BidPackageLineItem {
  id
  bidItem {
    id
  }
}
    `;
export const BidPackageLineItemModal_BidItemFragmentDoc = gql`
    fragment BidPackageLineItemModal_BidItem on BidItem {
  ...DisplayNamed
  name
  parentTask {
    ...Named
  }
  unitOfMeasure {
    id
    abbreviation
  }
  parentMaterialVariant {
    id
    code
    displayName
  }
  items {
    id
    costCode {
      ...DisplayNamed
    }
  }
  costType {
    code
  }
}
    ${DisplayNamedFragmentDoc}
${NamedFragmentDoc}`;
export const BidPackageLineItemModal_BidPackageLineItemFragmentDoc = gql`
    fragment BidPackageLineItemModal_BidPackageLineItem on BidPackageLineItem {
  id
  bidItem {
    ...DisplayNamed
    items {
      ...DisplayNamed
      costCode {
        ...DisplayNamed
      }
    }
  }
}
    ${DisplayNamedFragmentDoc}`;
export const BidPackageLineItemModal_BidPackageFragmentDoc = gql`
    fragment BidPackageLineItemModal_BidPackage on BidPackage {
  id
  name
  lineItems {
    ...BidPackageLineItemModal_BidPackageLineItem
  }
  costCodes {
    ...DisplayNamed
  }
  isUnitBased
}
    ${BidPackageLineItemModal_BidPackageLineItemFragmentDoc}
${DisplayNamedFragmentDoc}`;
export const BidMetaDocument = gql`
    query BidMeta($itemFilter: ItemFilter) {
  costTypes {
    name
    code
  }
  items(filter: $itemFilter) {
    id
    name
  }
  materialVariantTags {
    id
    name
  }
}
    `;

/**
 * __useBidMetaQuery__
 *
 * To run a query within a React component, call `useBidMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidMetaQuery({
 *   variables: {
 *      itemFilter: // value for 'itemFilter'
 *   },
 * });
 */
export function useBidMetaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidMetaQuery, BidMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidMetaQuery, BidMetaQueryVariables>(BidMetaDocument, options);
      }
export function useBidMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidMetaQuery, BidMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidMetaQuery, BidMetaQueryVariables>(BidMetaDocument, options);
        }
export function useBidMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidMetaQuery, BidMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidMetaQuery, BidMetaQueryVariables>(BidMetaDocument, options);
        }
export type BidMetaQueryHookResult = ReturnType<typeof useBidMetaQuery>;
export type BidMetaLazyQueryHookResult = ReturnType<typeof useBidMetaLazyQuery>;
export type BidMetaSuspenseQueryHookResult = ReturnType<typeof useBidMetaSuspenseQuery>;
export type BidMetaQueryResult = Apollo.QueryResult<BidMetaQuery, BidMetaQueryVariables>;
export const EditBidMetaDocument = gql`
    query EditBidMeta($itemFilter: ItemFilter, $bidPackageVersionId: ID!) {
  costTypes {
    name
    code
  }
  items(filter: $itemFilter) {
    id
    name
  }
  materialVariantTags {
    id
    name
  }
  bidPackageVersion(id: $bidPackageVersionId) {
    id
    lineItems {
      ...EditBidPackageLineItemModal_LineItem
    }
    previous {
      id
      lineItems {
        ...EditBidPackageLineItemModal_LineItem
      }
    }
  }
}
    ${EditBidPackageLineItemModal_LineItemFragmentDoc}`;

/**
 * __useEditBidMetaQuery__
 *
 * To run a query within a React component, call `useEditBidMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditBidMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditBidMetaQuery({
 *   variables: {
 *      itemFilter: // value for 'itemFilter'
 *      bidPackageVersionId: // value for 'bidPackageVersionId'
 *   },
 * });
 */
export function useEditBidMetaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditBidMetaQuery, EditBidMetaQueryVariables> & ({ variables: EditBidMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditBidMetaQuery, EditBidMetaQueryVariables>(EditBidMetaDocument, options);
      }
export function useEditBidMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditBidMetaQuery, EditBidMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditBidMetaQuery, EditBidMetaQueryVariables>(EditBidMetaDocument, options);
        }
export function useEditBidMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditBidMetaQuery, EditBidMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditBidMetaQuery, EditBidMetaQueryVariables>(EditBidMetaDocument, options);
        }
export type EditBidMetaQueryHookResult = ReturnType<typeof useEditBidMetaQuery>;
export type EditBidMetaLazyQueryHookResult = ReturnType<typeof useEditBidMetaLazyQuery>;
export type EditBidMetaSuspenseQueryHookResult = ReturnType<typeof useEditBidMetaSuspenseQuery>;
export type EditBidMetaQueryResult = Apollo.QueryResult<EditBidMetaQuery, EditBidMetaQueryVariables>;
export const BidPackageLineItemModalDocument = gql`
    query BidPackageLineItemModal($filter: PotentialBidItemsPageFilter!, $order: BidItemOrder, $first: Int, $offset: Int) {
  potentialBidItemsPage(
    filter: $filter
    order: $order
    first: $first
    offset: $offset
  ) {
    bidItems {
      ...BidPackageLineItemModal_BidItem
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${BidPackageLineItemModal_BidItemFragmentDoc}`;

/**
 * __useBidPackageLineItemModalQuery__
 *
 * To run a query within a React component, call `useBidPackageLineItemModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidPackageLineItemModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidPackageLineItemModalQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBidPackageLineItemModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidPackageLineItemModalQuery, BidPackageLineItemModalQueryVariables> & ({ variables: BidPackageLineItemModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidPackageLineItemModalQuery, BidPackageLineItemModalQueryVariables>(BidPackageLineItemModalDocument, options);
      }
export function useBidPackageLineItemModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidPackageLineItemModalQuery, BidPackageLineItemModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidPackageLineItemModalQuery, BidPackageLineItemModalQueryVariables>(BidPackageLineItemModalDocument, options);
        }
export function useBidPackageLineItemModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackageLineItemModalQuery, BidPackageLineItemModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidPackageLineItemModalQuery, BidPackageLineItemModalQueryVariables>(BidPackageLineItemModalDocument, options);
        }
export type BidPackageLineItemModalQueryHookResult = ReturnType<typeof useBidPackageLineItemModalQuery>;
export type BidPackageLineItemModalLazyQueryHookResult = ReturnType<typeof useBidPackageLineItemModalLazyQuery>;
export type BidPackageLineItemModalSuspenseQueryHookResult = ReturnType<typeof useBidPackageLineItemModalSuspenseQuery>;
export type BidPackageLineItemModalQueryResult = Apollo.QueryResult<BidPackageLineItemModalQuery, BidPackageLineItemModalQueryVariables>;